<template>
  <div class="footer">
    <div class="footer-content container">
      <div class="el-row gap-y">
        <div class="el-col-md-12 col-xl-8">
          <a href="/">
            <img src="../assets/logo.png" alt="logo" class="footer-logo" />
          </a>
          <p class="footer-title">火眼 - 移动广告营销情报分析平台</p>
        </div>

        <div
          class="el-col-12 el-col-md-12 el-col-xl-12"
          style="display: inline-flex"
        >
          <div style="width: 25%">
            <h6 class="title"><strong>功能与服务</strong></h6>
            <div class="nav flex-column">
              <router-link class="nav-link" :to="{ path: '/ad-material' }"
                >广告素材</router-link
              >
              <router-link class="nav-link" :to="{ path: '/adideas' }"
                >爆款文案</router-link
              >
              <router-link class="nav-link" :to="{ path: '/industry' }"
                >行业分析</router-link
              >
              <router-link class="nav-link" :to="{ path: '/admaster' }"
                >广告主榜单</router-link
              >
              <router-link class="nav-link" :to="{ path: '/ip' }"
                >综合定位服务</router-link
              >
            </div>
          </div>
          <div style="width: 25%">
            <h6 class="title"><strong>其他</strong></h6>
            <div class="nav flex-column">
              <a
                class="nav-link"
                href="https://www.admobile.top/aboutus.html"
                target="_blank"
                >公司简介</a
              ><a
                class="nav-link"
                href="https://www.admobile.top/privacyPolicy.html"
                target="_blank"
                >隐私政策</a
              >
            </div>
          </div>
          <div style="width: 50%">
            <h6 class="title"><strong>联系我们</strong></h6>
            <div class="nav flex-column">
              <p class="info">商务合作：orange@admobile.top</p>
              <p class="info">联系电话：15024425279</p>
              <p class="info">通讯地址：杭州市文二西路1号楼元茂大厦801室</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="site-info">
      <p>
        Copyright ©️ 杭州艾狄墨搏数字科技有限公司版权所有
        <a href="https://beian.miit.gov.cn/" target="_blank"
          >浙ICP备11040661号-5</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Footer extends Vue {}
</script>

<style lang="less" scoped>
.footer {
  overflow: hidden;
  font-family: PingFangSC-Medium, PingFang SC;
  border-top: 1px solid #1a1e21;
  box-shadow: 0px 1px 0px 2px rgba(255, 255, 255, 0.15);
  margin-top: 80px;

  .footer-logo {
    width: 250px;
    height: 70px;
    margin: 32px auto 0;
  }

  .footer-title {
    font-size: 20px;
    font-weight: 500;
    color: #ffffff;
    line-height: 28px;
    margin-top: 24px;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    line-height: 22px;
    margin: 46px 0 24px 0;
  }

  .nav {
    text-align: left;

    .nav-link,
    .info {
      display: block;
      text-decoration: none;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      margin-bottom: 16px;
    }
    .info {
      margin-bottom: 16px;
    }
  }

  .site-info {
    font-weight: 400;
    text-align: center;
    margin: 80px auto 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #ffffff;
    line-height: 20px;

    a {
      text-decoration: none;
      color: #ffffff;
    }
  }
}
</style>